module.exports = __webpack_public_path__ + "img/IMG_1923.3c18b636.jpg";